
  export const TAGS_RECEIVED = "TAGS_RECEIVED";
  export const SET_TAG = "SET_TAG";
  export const CREATE_TAG = "CREATE_TAG";
  export const SET_PROPERTY_TAG = "SET_PROPERTY_TAG";
  